export enum MessagePriority {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export enum AttachmentDocumentType {
    PDF = "PDF",
    Word = "Word",
    Excel = "Excel",
}

export enum MessageStatus {
    New = "New",
    Read = "Read",
    Archived = "Archived",
}

export enum StatusFilter {
    All = "ALL",
    Read = "READ",
    NotRead = "NOT_READ",
    Archived = "ARCHIVED",
}

export enum MessagePolicyType {
    Unspecified = "Unspecified",
    Life = "Life",
    Annuity = "Annuity",
    Application = "Application",
}

export class MessageConstants {
    public static DateCreatedKey = "DateCreated";
    public static MailToEmail = "MailToEmail";
    public static MailToSubject = "MailToSubject";
    public static NumberOfResultsPerPage = 10;
    public static SuggestionValidLength = 3;
    public static SearchValidLength = 3;
    public static SuggestionsLimit = 10;
    public static RecentNotificationsWidgetDisplayCount = 5;
}

export enum NotificationType {
    NewMessagesCount = "NewMessagesCount",
    PackageSubmitted = "PackageSubmitted",
    PackageSubmissionFailed = "PackageSubmissionFailed",
}

export enum NotificationsTableColumnNameHeader {
    Checkbox = "checkbox",
    Title = "title",
    Priority = "priority",
    Category = "category",
    DateCreated = "dateCreated",
    DueDate = "dueDate",
    PolicyIdentifier = "policyIdentifier",
    HasAttachments = "hasAttachments",
}

export const defaultRecentNotificationsConfig: RecentNotificationsDefinition = {
    defaultWidgetSize: 1,
};
